import type { BulkOperationJob, BulkOperationRow } from '../model/bulkOperations';

export const fixtureBulkOperations: Array<BulkOperationJob & { rows?: BulkOperationRow[] }> = [
  {
    id: 'bulk-employee',
    operationType: 'EMPLOYEE_HIRE',
    status: 'VALIDATED',
    originalFilename: '붙여넣기-2026-08-23.tsv',
    totalRows: 12,
    validRows: 11,
    succeededRows: 0,
    failedRows: 1,
    createdAt: '2026-08-23T09:00:00Z',
  },
  {
    id: 'bulk-1',
    operationType: 'STAFFING_CHANGE',
    status: 'QUEUED',
    originalFilename: '붙여넣기-2026-08-22.tsv',
    totalRows: 24,
    validRows: 24,
    succeededRows: 0,
    failedRows: 0,
    createdAt: '2026-08-22T09:00:00Z',
  },
  {
    id: 'bulk-2',
    operationType: 'TIME_OFF_CORRECTION',
    status: 'COMPLETED_WITH_ERRORS',
    originalFilename: '붙여넣기-2026-08-21.tsv',
    totalRows: 8,
    validRows: 8,
    succeededRows: 7,
    failedRows: 1,
    createdAt: '2026-08-21T09:00:00Z',
    rows: Array.from({ length: 8 }, (_, index) => ({
      rowNumber: index + 1,
      status: index === 7 ? 'FAILED' : 'SUCCEEDED',
      ...(index === 7 ? { errorCode: 'INVALID_REFERENCE', errorMessage: '정정할 휴가 기록을 찾을 수 없습니다. 대상과 날짜를 확인해 주세요.' } : {}),
    })),
  },
];
